import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';

export const specialHostsSlice = (state: RootState) => state.entities.specialHosts;

export const eventHostById = selectorsFactory.createEntityByIdSelector(specialHostsSlice);
